export default function getEms(pixels, base) {
  const baseFontSize = base || 16;
  return ((pixels / baseFontSize) * 100) / 100;
}
